import {
  FC,
  forwardRef,
  ReactElement,
  Ref,
  useEffect,
  useState,
} from 'react'
import { useSelector } from 'react-redux'

import { RootState } from 'dataStore/state'
import { IOrder } from 'dto/orders.dto'

import { useActions } from 'hooks/useActions'

import CloseIcon from '@mui/icons-material/Close'
import AppBar from '@mui/material/AppBar'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Slide from '@mui/material/Slide'
import Toolbar from '@mui/material/Toolbar'
import { TransitionProps } from '@mui/material/transitions'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'

import OrderDetails from './ordersTable/OrderDetails/OrderDetails'
import TotalBlock from './totalBlock'

import OrderTable from './ordersTable/Table'
import Filters from './ordersTable/filters'

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement
  },
  ref: Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

/**
 * Главный блок заказов: сводка, фильтры, серверная таблица.
 */
const OrdersTable: FC = () => {
  const { orders } = useSelector((state: RootState) => state.orders)
  const [selected, setSelected] = useState<IOrder | null>(null)
  const { getAllOrderStatus } = useActions()

  useEffect(() => {
    getAllOrderStatus()
  }, [])

  const handleClose = (): void => {
    setSelected(null)
  }

  return (
    <div>
      <TotalBlock />
      <Filters />
      <OrderTable orders={orders} setState={setSelected} />

      <Dialog
        disableEscapeKeyDown
        open={Boolean(selected)}
        onClose={handleClose}
        fullScreen
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={handleClose}
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
              Данные заказа
            </Typography>
            <Button autoFocus color='inherit' onClick={handleClose}>
              Сохранить
            </Button>
          </Toolbar>
        </AppBar>
        <OrderDetails state={selected} />
      </Dialog>
    </div>
  )
}

export default OrdersTable
